// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_0gBhedcRJp4F97d8nAX4","text":"_2aP_VVcFZTscnrJvjyCfbP"};